import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';
import { RefTypeRepository } from '../../../../store/ref-type-state/ref-type-state.repository';

interface getRefTypeDeleteObjectProps {
  t: TranslateService;
  store?: RefTypeRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getRefTypeDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getRefTypeDeleteObjectProps): DialogObject => {
  return {
    title: t.instant(`settings.refType.deleteConfirm`, {
      representation: representation,
    }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.dialog.confirm',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'common.dialog.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
